import { env } from "@/config/environment-vars";
import { productUrls } from "@/config/product-urls";
import {
  DatabaseIcon,
  EyeIcon,
  GlobeIcon,
  LayoutDashboardIcon,
  PlayIcon,
  SparklesIcon,
  TrophyIcon,
  UsersIcon,
  VideoIcon,
  WrenchIcon,
  type LucideIcon,
} from "lucide-react";

export interface ProductInfo {
  code: string;
  icon: LucideIcon;
  link: string | undefined;
}

export interface ProductInfos {
  [key: string]: ProductInfo;
}

const urlsForEnv = productUrls[env.VITE_ENVIRONMENT] ?? productUrls.dev;

export const productInfos: ProductInfos = {
  evo: {
    code: "evo",
    icon: EyeIcon,
    link: urlsForEnv.evo,
  },
  evo_admin: {
    code: "evo_admin",
    icon: SparklesIcon,
    link: urlsForEnv.evo,
  },
  video_stream_manager: {
    code: "video_stream_manager",
    icon: VideoIcon,
    link: urlsForEnv.video_stream_manager,
  },
  live_production_monitor: {
    code: "live_production_monitor",
    icon: LayoutDashboardIcon,
    link: urlsForEnv.live_production_monitor,
  },
  web: {
    code: "web",
    icon: GlobeIcon,
    link: urlsForEnv.web,
  },
  competition_manager: {
    code: "competition_manager",
    icon: TrophyIcon,
    link: urlsForEnv.competition_manager,
  },
  datacore: {
    code: "datacore",
    icon: DatabaseIcon,
    link: "#",
  },
  ingame: {
    code: "ingame",
    icon: PlayIcon,
    link: urlsForEnv.ingame,
  },
  internal_tools: {
    code: "internal_tools",
    icon: WrenchIcon,
    link: urlsForEnv.internal_tools,
  },
  user_manager: {
    code: "user_manager",
    icon: UsersIcon,
    link: urlsForEnv.user_manager,
  },
};

export function getProductInfo(code: string): ProductInfo {
  if (productInfos[code]) {
    return productInfos[code];
  }

  return {
    code,
    icon: GlobeIcon,
    link: "#",
  };
}
